/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Idle_TitleInputs */

const en_directory_search_idle_title = /** @type {(inputs: Directory_Search_Idle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are you looking for?`)
};

const zh_directory_search_idle_title = /** @type {(inputs: Directory_Search_Idle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你想找什么？`)
};

/**
* | output |
* | --- |
* | "What are you looking for?" |
*
* @param {Directory_Search_Idle_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_idle_title = /** @type {((inputs?: Directory_Search_Idle_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Idle_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_idle_title(inputs)
	return zh_directory_search_idle_title(inputs)
});
export { directory_search_idle_title as "directory.search.idle_title" }